import React, { useMemo } from "react";

const ErrorIcon = ({ width = 19, height = 19 }) => {
  const svgContent = useMemo(() => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 19 19"
      >
        <g id="Group_31224" data-name="Group 31224" transform="translate(0 0)">
          <circle
            id="Ellipse_230"
            data-name="Ellipse 230"
            cx="8.5"
            cy="8.5"
            r="8.5"
            transform="translate(0.639 1)"
            fill="#fff"
          />
          <g id="circle-error-svgrepo-com" transform="translate(0 0)">
            <path
              id="Path_17739"
              data-name="Path 17739"
              d="M16.271,2.854a9.492,9.492,0,1,0,.011,13.435,9.5,9.5,0,0,0-.011-13.435ZM11.485,13.561,9.467,11.543,7.448,13.561c-.824.824-1.443,1.541-2.426.56s-.267-1.6.561-2.426L7.6,9.677,5.583,7.659c-.825-.824-1.541-1.443-.561-2.426s1.6-.264,2.426.561L9.467,7.809l2.018-2.016c.825-.824,1.441-1.543,2.424-.561s.267,1.6-.558,2.426L11.332,9.676l2.018,2.017c.824.826,1.541,1.446.558,2.428s-1.6.264-2.424-.56Z"
              transform="translate(-0.059 -0.065)"
              fill="#d92315"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </svg>
    );
  }, []);
  return svgContent;
};

export default ErrorIcon;



// WEBPACK FOOTER //
// ./src/assets/ErrorIcon.jsx